import axios, { AxiosError } from 'axios';

interface IErrorBase<T> {
  error: Error | AxiosError<T>;
  type: 'axios-error' | 'stock-error';
}

interface IAxiosError<T> extends IErrorBase<T> {
  error: AxiosError<T>;
  type: 'axios-error';
}

interface IStockError<T> extends IErrorBase<T> {
  error: Error;
  type: 'stock-error';
}

type Args<T> = {
  error: Error | AxiosError;
  callback: (err: IAxiosError<T> | IStockError<T>) => void;
};

//inspired by https://github.com/axios/axios/issues/3612#issuecomment-893017210
export function axiosErrorHandler<T extends Record<string, unknown>>({
  error,
  callback,
}: Args<T>) {
  if (axios.isAxiosError<T, Record<string, unknown>>(error)) {
    callback({
      error: error,
      type: 'axios-error',
    });
  } else {
    callback({
      error: error,
      type: 'stock-error',
    });
  }
}
